import { eventConstants } from "../../../constants/event/event.constants";
import { alertActions } from "../alert.action";
import { eventLabelsConstants } from "../../../constants/event/eventLabel.constants";
import { eventLabelService } from "../../../services/core/eventLabelService";

export const eventLabelAction = {
    create,
    getGroup
};

function create(eventId, name, groupName, languageCode) {
    return dispatch => {
        dispatch(request(groupName));
        dispatch(alertActions.clear());
        eventLabelService.create(eventId, name, groupName, languageCode).then(
            label => {
                dispatch(success(label, groupName));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request(groupName) {
        return { type: eventLabelsConstants.CREATE_EVENTLABEL_REQUEST, groupName };
    }
    function success(label, groupName) {
        return { type: eventLabelsConstants.CREATE_EVENTLABEL_SUCCESS, label, groupName };
    }
    function failure(error) {
        return { type: eventLabelsConstants.CREATE_EVENTLABEL_FAILURE, error };
    }
}
function getGroup(eventId, groupName, languageCode) {
    return dispatch => {
        dispatch(request({groupName}));
        dispatch(alertActions.clear());
        eventLabelService.getGroup(eventId, groupName, languageCode).then(
            group => {
                dispatch(success(group, groupName));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request(groupName) {
        return { type: eventLabelsConstants.CREATE_EVENTLABEL_REQUEST, groupName };
    }
    function success(group, groupName) {
        return { type: eventLabelsConstants.GET_GROUP_EVENTLABEL_SUCCESS, group, groupName };
    }
    function failure(error) {
        return { type: eventLabelsConstants.GET_GROUP_EVENTLABEL_SUCCESS, error };
    }
}

